import { createRouter, createWebHistory } from "vue-router"
import MainApp from "@/app/MainAppTemplate.vue"
import MainTemplate  from "@/app/components/MainTemplate.vue"
import GeneralUserSkins from "@/modules/general/skins/UserComponent.vue"
import GeneralUserCars from "@/modules/general/cars/UserComponent.vue"
import GeneralUserAccessories from "@/modules/general/accessories/UserComponent.vue"
import AdminTemplate from "@/app/AdminAppTemplate.vue"
import LoginTemplate from "@/app/LoginTemplate.vue"
import VerificationTemplate from "@/app/VerificationTemplate.vue"
import { checkToken, checkVerified } from "@/extensions/funcs"


const routerAdminHandler = async () => {
	let status = false
	await checkToken().then(e => {
		status = e
	})
	if (status) {
		return true
	} else {
		return { path: "/login" }
	}
}
const routerVerifiedHandler = async() => {
	const status = await checkVerified()
	if (status === null) {
		return true
	} else if (status) {
		return true
	} else {
		return { path: "/login/verification" }
	}
}

const routerLoginHandler = async() => {
	let status = false
	await checkToken()
		.then(e => {
			status = e
		})
	if (status) {
		return { path: "/admin" }
	} else {
		return true
	}
}

const routes = [
	{
		path: "/",
		name: "main",
		component: MainApp,
		children: [
			{
				path: "/",
				component: MainTemplate,
				beforeEnter: [routerVerifiedHandler],
			},
			{
				path: "/general/skins",
				component: GeneralUserSkins,
				beforeEnter: [routerVerifiedHandler],
			},
			{
				path: "/general/cars",
				component: GeneralUserCars,
				beforeEnter: [routerVerifiedHandler],
			},
			{
				path: "/general/accessories",
				component: GeneralUserAccessories,
				beforeEnter: [routerVerifiedHandler],
			}
		]
	},
	{
		path: "/login",
		children: [
			{
				path: "",
				component: LoginTemplate,
				name: "login",
				beforeEnter: [routerLoginHandler]
			},
			{
				path: "verification",
				component: VerificationTemplate,
				name: "verification",
				// beforeEnter: [routerLoginHandler]
			}
		],
	},
	{
		path: "/admin",
		name: "admin",
		component: AdminTemplate,
		beforeEnter: [
			routerAdminHandler, routerVerifiedHandler
		],
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})


export default router